export default {
  shortList: [
    { name: "Manager", code: "manager" },
    { name: "Doctor", code: "doctor" },
    { name: "Trainee", code: "trainee" },
    { name: "Nurse", code: "nurse" },
    { name: "Administrator", code: "admin" }
  ]
};
